import { apiClient } from './client';

export const doctorApi = {
  getAll: (params) => apiClient.get('/doctors', { params }),
  getById: (id) => apiClient.get(`/doctors/${id}`),
  getActive: (params) => apiClient.get('/doctors/active', { params }),
  getReferralCount: (id) => apiClient.get(`/doctors/${id}/referral-count`),
  create: (data) => apiClient.post('/doctors', data),
  update: (id, data) => apiClient.put(`/doctors/${id}`, data),
  delete: (id) => apiClient.delete(`/doctors/${id}`),
};
